// Lib
import React, { ReactElement } from 'react';
import classNames from 'classnames';

// Styles
import './AiAssistantPopupResultHistory.scss';

interface AiAssistantPopupResultHistoryProps {
    children: Array<ReactElement | null> | ReactElement | string | undefined;
    className: string;
}

const AiAssistantPopupResultHistory = ({
    children,
    className,
}: AiAssistantPopupResultHistoryProps): React.ReactElement => {
    return <div className={classNames('AiAssistantPopupResultHistory', className)}>{children}</div>;
};

export default AiAssistantPopupResultHistory;
